<template>
  <div class="customer-archives">
    <div class="top_div">
      <img class="img_img" :src="(customerObj&&customerObj.headImg) || require('../../assets/img/user.png')" alt srcset />
      <div class="title_phone">{{customerObj&&customerObj.telephoneNumber}}</div>
    </div>
    <div class="center_div">
      <div class="title_name">—— 基本信息 ——</div>
    </div>
    <div class="bottom_div">
      <div class="obj_div">
        <div class="left_div">姓名</div>
        <div class="right_div">{{customerObj.name}}</div>
      </div>
      <div class="obj_div">
        <div class="left_div">手机号</div>
        <div class="right_div">{{customerObj.phoneNo}}</div>
      </div>
      <div class="obj_div">
        <div class="left_div">出生日期</div>
        <div class="right_div">
            <van-field
            v-model="customerObj.birthday"
            placeholder="出生日期"
            input-align="right"
            @click="showPicker = true"
            />
        </div>
      </div>
      <div class="obj_div">
        <div class="left_div">身份证</div>
        <div class="right_div">
            <van-field
            v-model="customerObj.idCard"
            placeholder="身份证"
            input-align="right"
            />
        </div>
      </div>
      <div class="obj_div">
        <div class="left_div">邮箱</div>
        <div class="right_div">
            <van-field
            v-model="customerObj.email"
            placeholder="邮箱"
            input-align="right"
            />
        </div>
      </div>
      <div class="obj_div">
        <div class="left_div">公司名称</div>
        <div class="right_div">
            <van-field
            v-model="customerObj.company"
            placeholder="公司名称"
            input-align="right"
            />
        </div>
      </div>
      <div class="obj_div">
        <div class="left_div">职位</div>
        <div class="right_div">
            <van-field
            v-model="customerObj.position"
            placeholder="职位"
            input-align="right"
            />
        </div>
      </div>
      <div class="obj_div">
        <div class="left_div">婚否</div>
        <div class="right_div">
            <van-radio-group v-model="customerObj.married" direction="horizontal">
                <van-radio checked-color="#FC6E09" name="1">已婚</van-radio>
                <van-radio checked-color="#FC6E09" name="0">未婚</van-radio>
            </van-radio-group>
        </div>
      </div>
      <div class="obj_div">
        <div class="left_div">是否有孩子</div>
        <div class="right_div">
            <van-radio-group v-model="customerObj.hasChild" direction="horizontal">
                <van-radio checked-color="#FC6E09" name="0">无</van-radio>
                <van-radio checked-color="#FC6E09" name="1">有</van-radio>
            </van-radio-group>
        </div>
      </div>
      <div class="obj_div">
        <div class="left_div">个人收入</div>
        <div class="right_div">
            <van-field
            v-model="customerObj.income"
            placeholder="个人收入"
            input-align="right"
            />
        </div>
      </div>
      <div class="obj_div">
        <div class="left_div">工作地</div>
        <div class="right_div">
            <van-field
            v-model="customerObj.workplace"
            placeholder="工作地"
            input-align="right"
            />
        </div>
      </div>
      <div class="obj_div">
        <div class="left_div">居住地</div>
        <div class="right_div">
            <van-field
            v-model="customerObj.residence"
            placeholder="居住地"
            input-align="right"
            />
        </div>
      </div>
    </div>
    <div class="btn_div">
      <div class="btn_btn" @click.prevent="editCustomer"></div>
    </div>
    <van-popup v-model="showPicker" position="bottom">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        title="选择年月日"
        :min-date="minDate"
        :max-date="maxDate"
         @confirm="onConfirm"
         @cancel="showPicker = false"
      />

    </van-popup>
  </div>
</template>
<script>
import URL from "@/api/api";
import { Toast } from "vant";
export default {
  name: "customerArchives",
  data() {
    return {
      customerObj: {},
      minDate: new Date(new Date().getFullYear()-150, new Date().getMonth(), new Date().getDay()),
      maxDate: new Date(),
      currentDate: new Date(2021, 0, 17),
      showPicker:false
    };
  },
  created() {
  },
  mounted(){
    this.getData()
  },
  methods: {
    timeFormat(time) { // 时间格式化 2019-09-08
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();
      return year + '-' + month + '-' + day
    },
    onConfirm(value) {
      this.customerObj.birthday =this.timeFormat(value) ;
      this.showPicker = false;
    },
    getData(){
      this.$fetchGet(URL.CustomerDetail.url, {cusId:this.$route.query.cusId}).then(res=>{
        this.customerObj=res.data.data
      })
    },
    editCustomer(){
      this.$fetchPost(URL.editCustomer.url, this.customerObj).then(res=>{
        if(res.data.code=='20000'){
          this.$router.replace('/myCustomer')
        }
      })
    }
  }
};
</script>
<style lang="less" scoped>
.customer-archives {
  width: 375px;
  height: 100vh;
  overflow: scroll;
  background: #ffffff;
  .top_div {
    width: 100%;
    height: 82px;
    background: url("./img/titleBg1.png") no-repeat;
    background-size: 100% 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: column;
    .img_img {
      width: 50px;
      height: 50px;
    }
    .title_phone {
      font-size: 11px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 15px;
      color: #ffffff;
      margin-top: 5px;
    }
  }
  .center_div {
    width: 100%;
    height: 20px;
    background: #fffbf8;
    display: flex;
    justify-content: center;
    align-items: center;
    margin-top: 10px;
    .title_name {
      height: 20px;
      line-height: 20px;
      text-align: center;
      font-size: 12px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 15px;
      color: #333333;
    }
  }
  .bottom_div {
    width: 100%;
    .obj_div {
      width: calc(100% - 30px);
      height: 33px;
      margin-left: 15px;
      display: flex;
      justify-content: space-between;
      align-items: center;
      font-size: 11px;
      font-family: Source Han Sans CN;
      font-weight: 400;
      line-height: 15px;
      color: #666666;
      .left_div {
        height: 100%;
        line-height: 33px;
        text-align: left;
      }
      .right_div {
        height: 100%;
        line-height: 33px;
        text-align: right;
        .van-field{
            padding: 0 !important;
        }
      }
    }
  }
  .btn_div {
    width: 100%;
    height: 34px;
    display: flex;
    justify-content: center;
    align-items: center;
    .btn_btn {
      width: 202px;
      height: 34px;
      margin-top: 25px;
      background: url("./img/btnSave.png") no-repeat;
      background-size: 100% 100%;
    }
  }
}
</style>